/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createFile = /* GraphQL */ `
  mutation CreateFile(
    $input: CreateFileInput!
    $condition: ModelFileConditionInput
  ) {
    createFile(input: $input, condition: $condition) {
      id
      bucket
      title
      size
      downloadTitle
      createdAt
      updatedAt
      deleted
      updatedBy
    }
  }
`;
export const updateFile = /* GraphQL */ `
  mutation UpdateFile(
    $input: UpdateFileInput!
    $condition: ModelFileConditionInput
  ) {
    updateFile(input: $input, condition: $condition) {
      id
      bucket
      title
      size
      downloadTitle
      createdAt
      updatedAt
      deleted
      updatedBy
    }
  }
`;
export const deleteFile = /* GraphQL */ `
  mutation DeleteFile(
    $input: DeleteFileInput!
    $condition: ModelFileConditionInput
  ) {
    deleteFile(input: $input, condition: $condition) {
      id
      bucket
      title
      size
      downloadTitle
      createdAt
      updatedAt
      deleted
      updatedBy
    }
  }
`;
export const createSetting = /* GraphQL */ `
  mutation CreateSetting(
    $input: CreateSettingInput!
    $condition: ModelSettingConditionInput
  ) {
    createSetting(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      type
      value
      userId
    }
  }
`;
export const updateSetting = /* GraphQL */ `
  mutation UpdateSetting(
    $input: UpdateSettingInput!
    $condition: ModelSettingConditionInput
  ) {
    updateSetting(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      type
      value
      userId
    }
  }
`;
export const deleteSetting = /* GraphQL */ `
  mutation DeleteSetting(
    $input: DeleteSettingInput!
    $condition: ModelSettingConditionInput
  ) {
    deleteSetting(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      type
      value
      userId
    }
  }
`;
export const createComment = /* GraphQL */ `
  mutation CreateComment(
    $input: CreateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    createComment(input: $input, condition: $condition) {
      id
      comment
      createdAt
      updatedAt
      deleted
      updatedBy
      updatedByFirstName
      updatedByLastName
    }
  }
`;
export const updateComment = /* GraphQL */ `
  mutation UpdateComment(
    $input: UpdateCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    updateComment(input: $input, condition: $condition) {
      id
      comment
      createdAt
      updatedAt
      deleted
      updatedBy
      updatedByFirstName
      updatedByLastName
    }
  }
`;
export const deleteComment = /* GraphQL */ `
  mutation DeleteComment(
    $input: DeleteCommentInput!
    $condition: ModelCommentConditionInput
  ) {
    deleteComment(input: $input, condition: $condition) {
      id
      comment
      createdAt
      updatedAt
      deleted
      updatedBy
      updatedByFirstName
      updatedByLastName
    }
  }
`;
export const createEmailRecord = /* GraphQL */ `
  mutation CreateEmailRecord(
    $input: CreateEmailRecordInput!
    $condition: ModelEmailRecordConditionInput
  ) {
    createEmailRecord(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      payload
      for
      userId
      status
      extraInformation
    }
  }
`;
export const updateEmailRecord = /* GraphQL */ `
  mutation UpdateEmailRecord(
    $input: UpdateEmailRecordInput!
    $condition: ModelEmailRecordConditionInput
  ) {
    updateEmailRecord(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      payload
      for
      userId
      status
      extraInformation
    }
  }
`;
export const deleteEmailRecord = /* GraphQL */ `
  mutation DeleteEmailRecord(
    $input: DeleteEmailRecordInput!
    $condition: ModelEmailRecordConditionInput
  ) {
    deleteEmailRecord(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      payload
      for
      userId
      status
      extraInformation
    }
  }
`;
export const createExtension = /* GraphQL */ `
  mutation CreateExtension(
    $input: CreateExtensionInput!
    $condition: ModelExtensionConditionInput
  ) {
    createExtension(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      year
      grant
      type
      group
      status
      for
      quarterFrom
      quarterTo
      dueDate
      reasonForExtension
      dateAdjustedTo
      reasonForAdjustment
      reasonForDeniedExtension
    }
  }
`;
export const updateExtension = /* GraphQL */ `
  mutation UpdateExtension(
    $input: UpdateExtensionInput!
    $condition: ModelExtensionConditionInput
  ) {
    updateExtension(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      year
      grant
      type
      group
      status
      for
      quarterFrom
      quarterTo
      dueDate
      reasonForExtension
      dateAdjustedTo
      reasonForAdjustment
      reasonForDeniedExtension
    }
  }
`;
export const deleteExtension = /* GraphQL */ `
  mutation DeleteExtension(
    $input: DeleteExtensionInput!
    $condition: ModelExtensionConditionInput
  ) {
    deleteExtension(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      year
      grant
      type
      group
      status
      for
      quarterFrom
      quarterTo
      dueDate
      reasonForExtension
      dateAdjustedTo
      reasonForAdjustment
      reasonForDeniedExtension
    }
  }
`;
export const createFinancialReimbursement = /* GraphQL */ `
  mutation CreateFinancialReimbursement(
    $input: CreateFinancialReimbursementInput!
    $condition: ModelFinancialReimbursementConditionInput
  ) {
    createFinancialReimbursement(input: $input, condition: $condition) {
      id
      quarter
      quarterStartDate
      quarterEndDate
      updatedBy
      year
      group {
        id
        groupName
        createdAt
        updatedAt
        region
        palmettoId
        narratives {
          nextToken
        }
        quarterlyprogressreporting {
          nextToken
        }
        awardAmount
        year
        grant
        deleted
        monitoringgrantinformation {
          id
          updatedAt
          createdAt
          updatedBy
          monitoringType
          monitoringDate
          subRecipientAgency
          grantProjectTitle
          grantNumber
          approvedGrantStartDate
          approvedGrantEndDate
          extensionEndDate
          name
          title
          projectDirectorName
          projectDirectorTitle
          personnelName
          personnelTitle
        }
        monitoringsitevisitreview {
          id
          updatedAt
          createdAt
          updatedBy
          gaOnFile
          gaSupportingDocumentationOnFile
          gaComments
          personnelFunded
          personnelDocumentationOnFile
          personnelRecordsOnFile
          personnelComments
          contractualServiceOnFile
          contractualServiceExecutedContractsOnFile
          contractualServiceComments
          travelOnFile
          travelDocumentationOnFile
          travelComments
          equipmentProperlySheltered
          equipmentTransferred
          equipmentComments
          suppliesOnFile
          suppliesTransferred
          suppliesComments
          otherOnFile
          otherComments
          summaryComments
          monitoringReportSubmittedBy
          monitoringReportSubmittedAt
          scemdPOCReviewedBy
          scemdPOCReviewedAt
          status
        }
        grantapplication {
          nextToken
        }
        financialreimbursement {
          nextToken
        }
      }
      createdAt
      updatedAt
      deleted
      status
      awarded
      checkNumber
      checkAmount
      checkMailDate
      checksReissued {
        items {
          id
          deleted
          updatedBy
          createdAt
          updatedAt
          checkNumber
          checkAmount
          checkMailDate
          reason
          checkNumber2
          checkAmount2
          checkMailDate2
          stateSceisDocumentNumber2
          stateSceisSubmissionDate2
          reason2
        }
        nextToken
      }
      currentReissuedCheck {
        id
        deleted
        updatedBy
        createdAt
        updatedAt
        checkNumber
        checkAmount
        checkMailDate
        reason
        checkNumber2
        checkAmount2
        checkMailDate2
        stateSceisDocumentNumber2
        stateSceisSubmissionDate2
        reason2
      }
      additionalChecks {
        items {
          id
          deleted
          updatedBy
          createdAt
          updatedAt
          checkNumber
          checkAmount
          checkMailDate
          stateSceisDocumentNumber
          stateSceisSubmissionDate
          reason
          checkNumber2
          checkAmount2
          checkMailDate2
          stateSceisDocumentNumber2
          stateSceisSubmissionDate2
          reason2
        }
        nextToken
      }
      additionalCheckInProgress {
        id
        deleted
        updatedBy
        createdAt
        updatedAt
        checkNumber
        checkAmount
        checkMailDate
        stateSceisDocumentNumber
        stateSceisSubmissionDate
        reason
        checkNumber2
        checkAmount2
        checkMailDate2
        stateSceisDocumentNumber2
        stateSceisSubmissionDate2
        reason2
      }
      stateSceisDocumentNumber
      stateSceisSubmissionDate
      extensions {
        items {
          id
          updatedAt
          createdAt
          updatedBy
          year
          grant
          type
          group
          status
          for
          quarterFrom
          quarterTo
          dueDate
          reasonForExtension
          dateAdjustedTo
          reasonForAdjustment
          reasonForDeniedExtension
        }
        nextToken
      }
      currentExtension {
        id
        updatedAt
        createdAt
        updatedBy
        year
        grant
        type
        group
        status
        for
        quarterFrom
        quarterTo
        dueDate
        reasonForExtension
        dateAdjustedTo
        reasonForAdjustment
        reasonForDeniedExtension
      }
      checkNumber2
      checkAmount2
      checkMailDate2
      stateSceisDocumentNumber2
      stateSceisSubmissionDate2
      reason2
      personnel {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      contractualService {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      travel {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      equipment {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      supply {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      cert {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      other {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      deobligatedFunds
      deobligatedFundsReason
    }
  }
`;
export const updateFinancialReimbursement = /* GraphQL */ `
  mutation UpdateFinancialReimbursement(
    $input: UpdateFinancialReimbursementInput!
    $condition: ModelFinancialReimbursementConditionInput
  ) {
    updateFinancialReimbursement(input: $input, condition: $condition) {
      id
      quarter
      quarterStartDate
      quarterEndDate
      updatedBy
      year
      group {
        id
        groupName
        createdAt
        updatedAt
        region
        palmettoId
        narratives {
          nextToken
        }
        quarterlyprogressreporting {
          nextToken
        }
        awardAmount
        year
        grant
        deleted
        monitoringgrantinformation {
          id
          updatedAt
          createdAt
          updatedBy
          monitoringType
          monitoringDate
          subRecipientAgency
          grantProjectTitle
          grantNumber
          approvedGrantStartDate
          approvedGrantEndDate
          extensionEndDate
          name
          title
          projectDirectorName
          projectDirectorTitle
          personnelName
          personnelTitle
        }
        monitoringsitevisitreview {
          id
          updatedAt
          createdAt
          updatedBy
          gaOnFile
          gaSupportingDocumentationOnFile
          gaComments
          personnelFunded
          personnelDocumentationOnFile
          personnelRecordsOnFile
          personnelComments
          contractualServiceOnFile
          contractualServiceExecutedContractsOnFile
          contractualServiceComments
          travelOnFile
          travelDocumentationOnFile
          travelComments
          equipmentProperlySheltered
          equipmentTransferred
          equipmentComments
          suppliesOnFile
          suppliesTransferred
          suppliesComments
          otherOnFile
          otherComments
          summaryComments
          monitoringReportSubmittedBy
          monitoringReportSubmittedAt
          scemdPOCReviewedBy
          scemdPOCReviewedAt
          status
        }
        grantapplication {
          nextToken
        }
        financialreimbursement {
          nextToken
        }
      }
      createdAt
      updatedAt
      deleted
      status
      awarded
      checkNumber
      checkAmount
      checkMailDate
      checksReissued {
        items {
          id
          deleted
          updatedBy
          createdAt
          updatedAt
          checkNumber
          checkAmount
          checkMailDate
          reason
          checkNumber2
          checkAmount2
          checkMailDate2
          stateSceisDocumentNumber2
          stateSceisSubmissionDate2
          reason2
        }
        nextToken
      }
      currentReissuedCheck {
        id
        deleted
        updatedBy
        createdAt
        updatedAt
        checkNumber
        checkAmount
        checkMailDate
        reason
        checkNumber2
        checkAmount2
        checkMailDate2
        stateSceisDocumentNumber2
        stateSceisSubmissionDate2
        reason2
      }
      additionalChecks {
        items {
          id
          deleted
          updatedBy
          createdAt
          updatedAt
          checkNumber
          checkAmount
          checkMailDate
          stateSceisDocumentNumber
          stateSceisSubmissionDate
          reason
          checkNumber2
          checkAmount2
          checkMailDate2
          stateSceisDocumentNumber2
          stateSceisSubmissionDate2
          reason2
        }
        nextToken
      }
      additionalCheckInProgress {
        id
        deleted
        updatedBy
        createdAt
        updatedAt
        checkNumber
        checkAmount
        checkMailDate
        stateSceisDocumentNumber
        stateSceisSubmissionDate
        reason
        checkNumber2
        checkAmount2
        checkMailDate2
        stateSceisDocumentNumber2
        stateSceisSubmissionDate2
        reason2
      }
      stateSceisDocumentNumber
      stateSceisSubmissionDate
      extensions {
        items {
          id
          updatedAt
          createdAt
          updatedBy
          year
          grant
          type
          group
          status
          for
          quarterFrom
          quarterTo
          dueDate
          reasonForExtension
          dateAdjustedTo
          reasonForAdjustment
          reasonForDeniedExtension
        }
        nextToken
      }
      currentExtension {
        id
        updatedAt
        createdAt
        updatedBy
        year
        grant
        type
        group
        status
        for
        quarterFrom
        quarterTo
        dueDate
        reasonForExtension
        dateAdjustedTo
        reasonForAdjustment
        reasonForDeniedExtension
      }
      checkNumber2
      checkAmount2
      checkMailDate2
      stateSceisDocumentNumber2
      stateSceisSubmissionDate2
      reason2
      personnel {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      contractualService {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      travel {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      equipment {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      supply {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      cert {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      other {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      deobligatedFunds
      deobligatedFundsReason
    }
  }
`;
export const deleteFinancialReimbursement = /* GraphQL */ `
  mutation DeleteFinancialReimbursement(
    $input: DeleteFinancialReimbursementInput!
    $condition: ModelFinancialReimbursementConditionInput
  ) {
    deleteFinancialReimbursement(input: $input, condition: $condition) {
      id
      quarter
      quarterStartDate
      quarterEndDate
      updatedBy
      year
      group {
        id
        groupName
        createdAt
        updatedAt
        region
        palmettoId
        narratives {
          nextToken
        }
        quarterlyprogressreporting {
          nextToken
        }
        awardAmount
        year
        grant
        deleted
        monitoringgrantinformation {
          id
          updatedAt
          createdAt
          updatedBy
          monitoringType
          monitoringDate
          subRecipientAgency
          grantProjectTitle
          grantNumber
          approvedGrantStartDate
          approvedGrantEndDate
          extensionEndDate
          name
          title
          projectDirectorName
          projectDirectorTitle
          personnelName
          personnelTitle
        }
        monitoringsitevisitreview {
          id
          updatedAt
          createdAt
          updatedBy
          gaOnFile
          gaSupportingDocumentationOnFile
          gaComments
          personnelFunded
          personnelDocumentationOnFile
          personnelRecordsOnFile
          personnelComments
          contractualServiceOnFile
          contractualServiceExecutedContractsOnFile
          contractualServiceComments
          travelOnFile
          travelDocumentationOnFile
          travelComments
          equipmentProperlySheltered
          equipmentTransferred
          equipmentComments
          suppliesOnFile
          suppliesTransferred
          suppliesComments
          otherOnFile
          otherComments
          summaryComments
          monitoringReportSubmittedBy
          monitoringReportSubmittedAt
          scemdPOCReviewedBy
          scemdPOCReviewedAt
          status
        }
        grantapplication {
          nextToken
        }
        financialreimbursement {
          nextToken
        }
      }
      createdAt
      updatedAt
      deleted
      status
      awarded
      checkNumber
      checkAmount
      checkMailDate
      checksReissued {
        items {
          id
          deleted
          updatedBy
          createdAt
          updatedAt
          checkNumber
          checkAmount
          checkMailDate
          reason
          checkNumber2
          checkAmount2
          checkMailDate2
          stateSceisDocumentNumber2
          stateSceisSubmissionDate2
          reason2
        }
        nextToken
      }
      currentReissuedCheck {
        id
        deleted
        updatedBy
        createdAt
        updatedAt
        checkNumber
        checkAmount
        checkMailDate
        reason
        checkNumber2
        checkAmount2
        checkMailDate2
        stateSceisDocumentNumber2
        stateSceisSubmissionDate2
        reason2
      }
      additionalChecks {
        items {
          id
          deleted
          updatedBy
          createdAt
          updatedAt
          checkNumber
          checkAmount
          checkMailDate
          stateSceisDocumentNumber
          stateSceisSubmissionDate
          reason
          checkNumber2
          checkAmount2
          checkMailDate2
          stateSceisDocumentNumber2
          stateSceisSubmissionDate2
          reason2
        }
        nextToken
      }
      additionalCheckInProgress {
        id
        deleted
        updatedBy
        createdAt
        updatedAt
        checkNumber
        checkAmount
        checkMailDate
        stateSceisDocumentNumber
        stateSceisSubmissionDate
        reason
        checkNumber2
        checkAmount2
        checkMailDate2
        stateSceisDocumentNumber2
        stateSceisSubmissionDate2
        reason2
      }
      stateSceisDocumentNumber
      stateSceisSubmissionDate
      extensions {
        items {
          id
          updatedAt
          createdAt
          updatedBy
          year
          grant
          type
          group
          status
          for
          quarterFrom
          quarterTo
          dueDate
          reasonForExtension
          dateAdjustedTo
          reasonForAdjustment
          reasonForDeniedExtension
        }
        nextToken
      }
      currentExtension {
        id
        updatedAt
        createdAt
        updatedBy
        year
        grant
        type
        group
        status
        for
        quarterFrom
        quarterTo
        dueDate
        reasonForExtension
        dateAdjustedTo
        reasonForAdjustment
        reasonForDeniedExtension
      }
      checkNumber2
      checkAmount2
      checkMailDate2
      stateSceisDocumentNumber2
      stateSceisSubmissionDate2
      reason2
      personnel {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      contractualService {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      travel {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      equipment {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      supply {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      cert {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      other {
        items {
          id
          deleted
          updatedBy
          positionTitle
          quarterAmount
          matchAmount
          taxAmount
          file
          createdAt
          updatedAt
        }
        nextToken
      }
      deobligatedFunds
      deobligatedFundsReason
    }
  }
`;
export const createChecksReissued = /* GraphQL */ `
  mutation CreateChecksReissued(
    $input: CreateChecksReissuedInput!
    $condition: ModelChecksReissuedConditionInput
  ) {
    createChecksReissued(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      createdAt
      updatedAt
      checkNumber
      checkAmount
      checkMailDate
      reason
      checkNumber2
      checkAmount2
      checkMailDate2
      stateSceisDocumentNumber2
      stateSceisSubmissionDate2
      reason2
    }
  }
`;
export const updateChecksReissued = /* GraphQL */ `
  mutation UpdateChecksReissued(
    $input: UpdateChecksReissuedInput!
    $condition: ModelChecksReissuedConditionInput
  ) {
    updateChecksReissued(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      createdAt
      updatedAt
      checkNumber
      checkAmount
      checkMailDate
      reason
      checkNumber2
      checkAmount2
      checkMailDate2
      stateSceisDocumentNumber2
      stateSceisSubmissionDate2
      reason2
    }
  }
`;
export const deleteChecksReissued = /* GraphQL */ `
  mutation DeleteChecksReissued(
    $input: DeleteChecksReissuedInput!
    $condition: ModelChecksReissuedConditionInput
  ) {
    deleteChecksReissued(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      createdAt
      updatedAt
      checkNumber
      checkAmount
      checkMailDate
      reason
      checkNumber2
      checkAmount2
      checkMailDate2
      stateSceisDocumentNumber2
      stateSceisSubmissionDate2
      reason2
    }
  }
`;
export const createAdditionalChecks = /* GraphQL */ `
  mutation CreateAdditionalChecks(
    $input: CreateAdditionalChecksInput!
    $condition: ModelAdditionalChecksConditionInput
  ) {
    createAdditionalChecks(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      createdAt
      updatedAt
      checkNumber
      checkAmount
      checkMailDate
      stateSceisDocumentNumber
      stateSceisSubmissionDate
      reason
      checkNumber2
      checkAmount2
      checkMailDate2
      stateSceisDocumentNumber2
      stateSceisSubmissionDate2
      reason2
    }
  }
`;
export const updateAdditionalChecks = /* GraphQL */ `
  mutation UpdateAdditionalChecks(
    $input: UpdateAdditionalChecksInput!
    $condition: ModelAdditionalChecksConditionInput
  ) {
    updateAdditionalChecks(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      createdAt
      updatedAt
      checkNumber
      checkAmount
      checkMailDate
      stateSceisDocumentNumber
      stateSceisSubmissionDate
      reason
      checkNumber2
      checkAmount2
      checkMailDate2
      stateSceisDocumentNumber2
      stateSceisSubmissionDate2
      reason2
    }
  }
`;
export const deleteAdditionalChecks = /* GraphQL */ `
  mutation DeleteAdditionalChecks(
    $input: DeleteAdditionalChecksInput!
    $condition: ModelAdditionalChecksConditionInput
  ) {
    deleteAdditionalChecks(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      createdAt
      updatedAt
      checkNumber
      checkAmount
      checkMailDate
      stateSceisDocumentNumber
      stateSceisSubmissionDate
      reason
      checkNumber2
      checkAmount2
      checkMailDate2
      stateSceisDocumentNumber2
      stateSceisSubmissionDate2
      reason2
    }
  }
`;
export const createFimPersonnel = /* GraphQL */ `
  mutation CreateFimPersonnel(
    $input: CreateFimPersonnelInput!
    $condition: ModelFimPersonnelConditionInput
  ) {
    createFimPersonnel(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const updateFimPersonnel = /* GraphQL */ `
  mutation UpdateFimPersonnel(
    $input: UpdateFimPersonnelInput!
    $condition: ModelFimPersonnelConditionInput
  ) {
    updateFimPersonnel(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const deleteFimPersonnel = /* GraphQL */ `
  mutation DeleteFimPersonnel(
    $input: DeleteFimPersonnelInput!
    $condition: ModelFimPersonnelConditionInput
  ) {
    deleteFimPersonnel(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const createFimContractualService = /* GraphQL */ `
  mutation CreateFimContractualService(
    $input: CreateFimContractualServiceInput!
    $condition: ModelFimContractualServiceConditionInput
  ) {
    createFimContractualService(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const updateFimContractualService = /* GraphQL */ `
  mutation UpdateFimContractualService(
    $input: UpdateFimContractualServiceInput!
    $condition: ModelFimContractualServiceConditionInput
  ) {
    updateFimContractualService(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const deleteFimContractualService = /* GraphQL */ `
  mutation DeleteFimContractualService(
    $input: DeleteFimContractualServiceInput!
    $condition: ModelFimContractualServiceConditionInput
  ) {
    deleteFimContractualService(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const createFimTravel = /* GraphQL */ `
  mutation CreateFimTravel(
    $input: CreateFimTravelInput!
    $condition: ModelFimTravelConditionInput
  ) {
    createFimTravel(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const updateFimTravel = /* GraphQL */ `
  mutation UpdateFimTravel(
    $input: UpdateFimTravelInput!
    $condition: ModelFimTravelConditionInput
  ) {
    updateFimTravel(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const deleteFimTravel = /* GraphQL */ `
  mutation DeleteFimTravel(
    $input: DeleteFimTravelInput!
    $condition: ModelFimTravelConditionInput
  ) {
    deleteFimTravel(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const createFimEquipment = /* GraphQL */ `
  mutation CreateFimEquipment(
    $input: CreateFimEquipmentInput!
    $condition: ModelFimEquipmentConditionInput
  ) {
    createFimEquipment(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const updateFimEquipment = /* GraphQL */ `
  mutation UpdateFimEquipment(
    $input: UpdateFimEquipmentInput!
    $condition: ModelFimEquipmentConditionInput
  ) {
    updateFimEquipment(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const deleteFimEquipment = /* GraphQL */ `
  mutation DeleteFimEquipment(
    $input: DeleteFimEquipmentInput!
    $condition: ModelFimEquipmentConditionInput
  ) {
    deleteFimEquipment(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const createFimSupply = /* GraphQL */ `
  mutation CreateFimSupply(
    $input: CreateFimSupplyInput!
    $condition: ModelFimSupplyConditionInput
  ) {
    createFimSupply(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const updateFimSupply = /* GraphQL */ `
  mutation UpdateFimSupply(
    $input: UpdateFimSupplyInput!
    $condition: ModelFimSupplyConditionInput
  ) {
    updateFimSupply(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const deleteFimSupply = /* GraphQL */ `
  mutation DeleteFimSupply(
    $input: DeleteFimSupplyInput!
    $condition: ModelFimSupplyConditionInput
  ) {
    deleteFimSupply(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const createFimCert = /* GraphQL */ `
  mutation CreateFimCert(
    $input: CreateFimCertInput!
    $condition: ModelFimCertConditionInput
  ) {
    createFimCert(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const updateFimCert = /* GraphQL */ `
  mutation UpdateFimCert(
    $input: UpdateFimCertInput!
    $condition: ModelFimCertConditionInput
  ) {
    updateFimCert(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const deleteFimCert = /* GraphQL */ `
  mutation DeleteFimCert(
    $input: DeleteFimCertInput!
    $condition: ModelFimCertConditionInput
  ) {
    deleteFimCert(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const createFimOther = /* GraphQL */ `
  mutation CreateFimOther(
    $input: CreateFimOtherInput!
    $condition: ModelFimOtherConditionInput
  ) {
    createFimOther(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const updateFimOther = /* GraphQL */ `
  mutation UpdateFimOther(
    $input: UpdateFimOtherInput!
    $condition: ModelFimOtherConditionInput
  ) {
    updateFimOther(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const deleteFimOther = /* GraphQL */ `
  mutation DeleteFimOther(
    $input: DeleteFimOtherInput!
    $condition: ModelFimOtherConditionInput
  ) {
    deleteFimOther(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      positionTitle
      quarterAmount
      matchAmount
      taxAmount
      file
      createdAt
      updatedAt
    }
  }
`;
export const createGrantApplication = /* GraphQL */ `
  mutation CreateGrantApplication(
    $input: CreateGrantApplicationInput!
    $condition: ModelGrantApplicationConditionInput
  ) {
    createGrantApplication(input: $input, condition: $condition) {
      id
      group {
        id
        groupName
        createdAt
        updatedAt
        region
        palmettoId
        narratives {
          nextToken
        }
        quarterlyprogressreporting {
          nextToken
        }
        awardAmount
        year
        grant
        deleted
        monitoringgrantinformation {
          id
          updatedAt
          createdAt
          updatedBy
          monitoringType
          monitoringDate
          subRecipientAgency
          grantProjectTitle
          grantNumber
          approvedGrantStartDate
          approvedGrantEndDate
          extensionEndDate
          name
          title
          projectDirectorName
          projectDirectorTitle
          personnelName
          personnelTitle
        }
        monitoringsitevisitreview {
          id
          updatedAt
          createdAt
          updatedBy
          gaOnFile
          gaSupportingDocumentationOnFile
          gaComments
          personnelFunded
          personnelDocumentationOnFile
          personnelRecordsOnFile
          personnelComments
          contractualServiceOnFile
          contractualServiceExecutedContractsOnFile
          contractualServiceComments
          travelOnFile
          travelDocumentationOnFile
          travelComments
          equipmentProperlySheltered
          equipmentTransferred
          equipmentComments
          suppliesOnFile
          suppliesTransferred
          suppliesComments
          otherOnFile
          otherComments
          summaryComments
          monitoringReportSubmittedBy
          monitoringReportSubmittedAt
          scemdPOCReviewedBy
          scemdPOCReviewedAt
          status
        }
        grantapplication {
          nextToken
        }
        financialreimbursement {
          nextToken
        }
      }
      updatedBy
      version
      versionName
      createdAt
      updatedAt
      year
      deleted
      status
      awarded
      deductCertFromFederal
      salary {
        items {
          id
          deleted
          updatedBy
          name
          positionTitle
          federal
          county
          countyInKind
          fbFederalFunding
          fbCountyCashFunding
          fbCountyInkindFunding
          createdAt
          updatedAt
        }
        nextToken
      }
      salaryNarrative
      fringeBenefit {
        id
        deleted
        updatedBy
        federal
        county
        countyInKind
        createdAt
        updatedAt
      }
      fringeBenefitNarrative
      fbFederalFunding
      fbCountyCashFunding
      fbCountyInkindFunding
      contractualService {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      contractualServiceNarrative
      travel {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      travelNarrative
      equipment {
        items {
          id
          name
          femaItemNumber
          quantity
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      equipmentNarrative
      supply {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      supplyNarrative
      other {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      otherNarrative
      cert {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      certNarrative
      acceptanceOfAuditReqFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      certificationDocumentFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      assurancesNonContructionFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      lobbyingCertificationFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      edmEquipmentPolicyFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      positionDescFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      acknowledgementFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      otherFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      scopeOfWorkFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      narrativesFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      extraFile
      awardDocumentsUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardCoverLetterUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardDocumentUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardSpecialInstructionsUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardDocumentsUploadedByCounty {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      changesRequestedOnApplication
      name
      address
      address2
      city
      state
      county
      zipcode
      latitude
      longitude
      enableReverseGeocoding
      implementingAgency
      phoneNumber
      faxNumber
      currentApplicationRevisionId
      grantApplicationRevision {
        items {
          id
          createdAt
          updatedAt
          grantApplicationLastUpdatedAt
          updatedBy
        }
        nextToken
      }
      extensions {
        items {
          id
          updatedAt
          createdAt
          updatedBy
          year
          grant
          type
          group
          status
          for
          quarterFrom
          quarterTo
          dueDate
          reasonForExtension
          dateAdjustedTo
          reasonForAdjustment
          reasonForDeniedExtension
        }
        nextToken
      }
      currentExtension {
        id
        updatedAt
        createdAt
        updatedBy
        year
        grant
        type
        group
        status
        for
        quarterFrom
        quarterTo
        dueDate
        reasonForExtension
        dateAdjustedTo
        reasonForAdjustment
        reasonForDeniedExtension
      }
    }
  }
`;
export const updateGrantApplication = /* GraphQL */ `
  mutation UpdateGrantApplication(
    $input: UpdateGrantApplicationInput!
    $condition: ModelGrantApplicationConditionInput
  ) {
    updateGrantApplication(input: $input, condition: $condition) {
      id
      group {
        id
        groupName
        createdAt
        updatedAt
        region
        palmettoId
        narratives {
          nextToken
        }
        quarterlyprogressreporting {
          nextToken
        }
        awardAmount
        year
        grant
        deleted
        monitoringgrantinformation {
          id
          updatedAt
          createdAt
          updatedBy
          monitoringType
          monitoringDate
          subRecipientAgency
          grantProjectTitle
          grantNumber
          approvedGrantStartDate
          approvedGrantEndDate
          extensionEndDate
          name
          title
          projectDirectorName
          projectDirectorTitle
          personnelName
          personnelTitle
        }
        monitoringsitevisitreview {
          id
          updatedAt
          createdAt
          updatedBy
          gaOnFile
          gaSupportingDocumentationOnFile
          gaComments
          personnelFunded
          personnelDocumentationOnFile
          personnelRecordsOnFile
          personnelComments
          contractualServiceOnFile
          contractualServiceExecutedContractsOnFile
          contractualServiceComments
          travelOnFile
          travelDocumentationOnFile
          travelComments
          equipmentProperlySheltered
          equipmentTransferred
          equipmentComments
          suppliesOnFile
          suppliesTransferred
          suppliesComments
          otherOnFile
          otherComments
          summaryComments
          monitoringReportSubmittedBy
          monitoringReportSubmittedAt
          scemdPOCReviewedBy
          scemdPOCReviewedAt
          status
        }
        grantapplication {
          nextToken
        }
        financialreimbursement {
          nextToken
        }
      }
      updatedBy
      version
      versionName
      createdAt
      updatedAt
      year
      deleted
      status
      awarded
      deductCertFromFederal
      salary {
        items {
          id
          deleted
          updatedBy
          name
          positionTitle
          federal
          county
          countyInKind
          fbFederalFunding
          fbCountyCashFunding
          fbCountyInkindFunding
          createdAt
          updatedAt
        }
        nextToken
      }
      salaryNarrative
      fringeBenefit {
        id
        deleted
        updatedBy
        federal
        county
        countyInKind
        createdAt
        updatedAt
      }
      fringeBenefitNarrative
      fbFederalFunding
      fbCountyCashFunding
      fbCountyInkindFunding
      contractualService {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      contractualServiceNarrative
      travel {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      travelNarrative
      equipment {
        items {
          id
          name
          femaItemNumber
          quantity
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      equipmentNarrative
      supply {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      supplyNarrative
      other {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      otherNarrative
      cert {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      certNarrative
      acceptanceOfAuditReqFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      certificationDocumentFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      assurancesNonContructionFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      lobbyingCertificationFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      edmEquipmentPolicyFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      positionDescFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      acknowledgementFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      otherFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      scopeOfWorkFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      narrativesFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      extraFile
      awardDocumentsUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardCoverLetterUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardDocumentUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardSpecialInstructionsUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardDocumentsUploadedByCounty {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      changesRequestedOnApplication
      name
      address
      address2
      city
      state
      county
      zipcode
      latitude
      longitude
      enableReverseGeocoding
      implementingAgency
      phoneNumber
      faxNumber
      currentApplicationRevisionId
      grantApplicationRevision {
        items {
          id
          createdAt
          updatedAt
          grantApplicationLastUpdatedAt
          updatedBy
        }
        nextToken
      }
      extensions {
        items {
          id
          updatedAt
          createdAt
          updatedBy
          year
          grant
          type
          group
          status
          for
          quarterFrom
          quarterTo
          dueDate
          reasonForExtension
          dateAdjustedTo
          reasonForAdjustment
          reasonForDeniedExtension
        }
        nextToken
      }
      currentExtension {
        id
        updatedAt
        createdAt
        updatedBy
        year
        grant
        type
        group
        status
        for
        quarterFrom
        quarterTo
        dueDate
        reasonForExtension
        dateAdjustedTo
        reasonForAdjustment
        reasonForDeniedExtension
      }
    }
  }
`;
export const deleteGrantApplication = /* GraphQL */ `
  mutation DeleteGrantApplication(
    $input: DeleteGrantApplicationInput!
    $condition: ModelGrantApplicationConditionInput
  ) {
    deleteGrantApplication(input: $input, condition: $condition) {
      id
      group {
        id
        groupName
        createdAt
        updatedAt
        region
        palmettoId
        narratives {
          nextToken
        }
        quarterlyprogressreporting {
          nextToken
        }
        awardAmount
        year
        grant
        deleted
        monitoringgrantinformation {
          id
          updatedAt
          createdAt
          updatedBy
          monitoringType
          monitoringDate
          subRecipientAgency
          grantProjectTitle
          grantNumber
          approvedGrantStartDate
          approvedGrantEndDate
          extensionEndDate
          name
          title
          projectDirectorName
          projectDirectorTitle
          personnelName
          personnelTitle
        }
        monitoringsitevisitreview {
          id
          updatedAt
          createdAt
          updatedBy
          gaOnFile
          gaSupportingDocumentationOnFile
          gaComments
          personnelFunded
          personnelDocumentationOnFile
          personnelRecordsOnFile
          personnelComments
          contractualServiceOnFile
          contractualServiceExecutedContractsOnFile
          contractualServiceComments
          travelOnFile
          travelDocumentationOnFile
          travelComments
          equipmentProperlySheltered
          equipmentTransferred
          equipmentComments
          suppliesOnFile
          suppliesTransferred
          suppliesComments
          otherOnFile
          otherComments
          summaryComments
          monitoringReportSubmittedBy
          monitoringReportSubmittedAt
          scemdPOCReviewedBy
          scemdPOCReviewedAt
          status
        }
        grantapplication {
          nextToken
        }
        financialreimbursement {
          nextToken
        }
      }
      updatedBy
      version
      versionName
      createdAt
      updatedAt
      year
      deleted
      status
      awarded
      deductCertFromFederal
      salary {
        items {
          id
          deleted
          updatedBy
          name
          positionTitle
          federal
          county
          countyInKind
          fbFederalFunding
          fbCountyCashFunding
          fbCountyInkindFunding
          createdAt
          updatedAt
        }
        nextToken
      }
      salaryNarrative
      fringeBenefit {
        id
        deleted
        updatedBy
        federal
        county
        countyInKind
        createdAt
        updatedAt
      }
      fringeBenefitNarrative
      fbFederalFunding
      fbCountyCashFunding
      fbCountyInkindFunding
      contractualService {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      contractualServiceNarrative
      travel {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      travelNarrative
      equipment {
        items {
          id
          name
          femaItemNumber
          quantity
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      equipmentNarrative
      supply {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      supplyNarrative
      other {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      otherNarrative
      cert {
        items {
          id
          name
          deleted
          updatedBy
          federal
          county
          countyInKind
          createdAt
          updatedAt
        }
        nextToken
      }
      certNarrative
      acceptanceOfAuditReqFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      certificationDocumentFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      assurancesNonContructionFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      lobbyingCertificationFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      edmEquipmentPolicyFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      positionDescFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      acknowledgementFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      otherFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      scopeOfWorkFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      narrativesFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      extraFile
      awardDocumentsUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardCoverLetterUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardDocumentUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardSpecialInstructionsUploadedByState {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      awardDocumentsUploadedByCounty {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      changesRequestedOnApplication
      name
      address
      address2
      city
      state
      county
      zipcode
      latitude
      longitude
      enableReverseGeocoding
      implementingAgency
      phoneNumber
      faxNumber
      currentApplicationRevisionId
      grantApplicationRevision {
        items {
          id
          createdAt
          updatedAt
          grantApplicationLastUpdatedAt
          updatedBy
        }
        nextToken
      }
      extensions {
        items {
          id
          updatedAt
          createdAt
          updatedBy
          year
          grant
          type
          group
          status
          for
          quarterFrom
          quarterTo
          dueDate
          reasonForExtension
          dateAdjustedTo
          reasonForAdjustment
          reasonForDeniedExtension
        }
        nextToken
      }
      currentExtension {
        id
        updatedAt
        createdAt
        updatedBy
        year
        grant
        type
        group
        status
        for
        quarterFrom
        quarterTo
        dueDate
        reasonForExtension
        dateAdjustedTo
        reasonForAdjustment
        reasonForDeniedExtension
      }
    }
  }
`;
export const createGrantApplicationRevision = /* GraphQL */ `
  mutation CreateGrantApplicationRevision(
    $input: CreateGrantApplicationRevisionInput!
    $condition: ModelGrantApplicationRevisionConditionInput
  ) {
    createGrantApplicationRevision(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      grantApplicationLastUpdatedAt
      revision {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      updatedBy
    }
  }
`;
export const updateGrantApplicationRevision = /* GraphQL */ `
  mutation UpdateGrantApplicationRevision(
    $input: UpdateGrantApplicationRevisionInput!
    $condition: ModelGrantApplicationRevisionConditionInput
  ) {
    updateGrantApplicationRevision(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      grantApplicationLastUpdatedAt
      revision {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      updatedBy
    }
  }
`;
export const deleteGrantApplicationRevision = /* GraphQL */ `
  mutation DeleteGrantApplicationRevision(
    $input: DeleteGrantApplicationRevisionInput!
    $condition: ModelGrantApplicationRevisionConditionInput
  ) {
    deleteGrantApplicationRevision(input: $input, condition: $condition) {
      id
      createdAt
      updatedAt
      grantApplicationLastUpdatedAt
      revision {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      updatedBy
    }
  }
`;
export const createSalary = /* GraphQL */ `
  mutation CreateSalary(
    $input: CreateSalaryInput!
    $condition: ModelSalaryConditionInput
  ) {
    createSalary(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      name
      positionTitle
      federal
      county
      countyInKind
      fbFederalFunding
      fbCountyCashFunding
      fbCountyInkindFunding
      createdAt
      updatedAt
    }
  }
`;
export const updateSalary = /* GraphQL */ `
  mutation UpdateSalary(
    $input: UpdateSalaryInput!
    $condition: ModelSalaryConditionInput
  ) {
    updateSalary(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      name
      positionTitle
      federal
      county
      countyInKind
      fbFederalFunding
      fbCountyCashFunding
      fbCountyInkindFunding
      createdAt
      updatedAt
    }
  }
`;
export const deleteSalary = /* GraphQL */ `
  mutation DeleteSalary(
    $input: DeleteSalaryInput!
    $condition: ModelSalaryConditionInput
  ) {
    deleteSalary(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      name
      positionTitle
      federal
      county
      countyInKind
      fbFederalFunding
      fbCountyCashFunding
      fbCountyInkindFunding
      createdAt
      updatedAt
    }
  }
`;
export const createFringeBenefit = /* GraphQL */ `
  mutation CreateFringeBenefit(
    $input: CreateFringeBenefitInput!
    $condition: ModelFringeBenefitConditionInput
  ) {
    createFringeBenefit(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const updateFringeBenefit = /* GraphQL */ `
  mutation UpdateFringeBenefit(
    $input: UpdateFringeBenefitInput!
    $condition: ModelFringeBenefitConditionInput
  ) {
    updateFringeBenefit(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const deleteFringeBenefit = /* GraphQL */ `
  mutation DeleteFringeBenefit(
    $input: DeleteFringeBenefitInput!
    $condition: ModelFringeBenefitConditionInput
  ) {
    deleteFringeBenefit(input: $input, condition: $condition) {
      id
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const createContractualService = /* GraphQL */ `
  mutation CreateContractualService(
    $input: CreateContractualServiceInput!
    $condition: ModelContractualServiceConditionInput
  ) {
    createContractualService(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const updateContractualService = /* GraphQL */ `
  mutation UpdateContractualService(
    $input: UpdateContractualServiceInput!
    $condition: ModelContractualServiceConditionInput
  ) {
    updateContractualService(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const deleteContractualService = /* GraphQL */ `
  mutation DeleteContractualService(
    $input: DeleteContractualServiceInput!
    $condition: ModelContractualServiceConditionInput
  ) {
    deleteContractualService(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const createTravel = /* GraphQL */ `
  mutation CreateTravel(
    $input: CreateTravelInput!
    $condition: ModelTravelConditionInput
  ) {
    createTravel(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const updateTravel = /* GraphQL */ `
  mutation UpdateTravel(
    $input: UpdateTravelInput!
    $condition: ModelTravelConditionInput
  ) {
    updateTravel(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const deleteTravel = /* GraphQL */ `
  mutation DeleteTravel(
    $input: DeleteTravelInput!
    $condition: ModelTravelConditionInput
  ) {
    deleteTravel(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const createEquipment = /* GraphQL */ `
  mutation CreateEquipment(
    $input: CreateEquipmentInput!
    $condition: ModelEquipmentConditionInput
  ) {
    createEquipment(input: $input, condition: $condition) {
      id
      name
      femaItemNumber
      quantity
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const updateEquipment = /* GraphQL */ `
  mutation UpdateEquipment(
    $input: UpdateEquipmentInput!
    $condition: ModelEquipmentConditionInput
  ) {
    updateEquipment(input: $input, condition: $condition) {
      id
      name
      femaItemNumber
      quantity
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const deleteEquipment = /* GraphQL */ `
  mutation DeleteEquipment(
    $input: DeleteEquipmentInput!
    $condition: ModelEquipmentConditionInput
  ) {
    deleteEquipment(input: $input, condition: $condition) {
      id
      name
      femaItemNumber
      quantity
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const createSupply = /* GraphQL */ `
  mutation CreateSupply(
    $input: CreateSupplyInput!
    $condition: ModelSupplyConditionInput
  ) {
    createSupply(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const updateSupply = /* GraphQL */ `
  mutation UpdateSupply(
    $input: UpdateSupplyInput!
    $condition: ModelSupplyConditionInput
  ) {
    updateSupply(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const deleteSupply = /* GraphQL */ `
  mutation DeleteSupply(
    $input: DeleteSupplyInput!
    $condition: ModelSupplyConditionInput
  ) {
    deleteSupply(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const createOther = /* GraphQL */ `
  mutation CreateOther(
    $input: CreateOtherInput!
    $condition: ModelOtherConditionInput
  ) {
    createOther(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const updateOther = /* GraphQL */ `
  mutation UpdateOther(
    $input: UpdateOtherInput!
    $condition: ModelOtherConditionInput
  ) {
    updateOther(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const deleteOther = /* GraphQL */ `
  mutation DeleteOther(
    $input: DeleteOtherInput!
    $condition: ModelOtherConditionInput
  ) {
    deleteOther(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const createCert = /* GraphQL */ `
  mutation CreateCert(
    $input: CreateCertInput!
    $condition: ModelCertConditionInput
  ) {
    createCert(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const updateCert = /* GraphQL */ `
  mutation UpdateCert(
    $input: UpdateCertInput!
    $condition: ModelCertConditionInput
  ) {
    updateCert(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const deleteCert = /* GraphQL */ `
  mutation DeleteCert(
    $input: DeleteCertInput!
    $condition: ModelCertConditionInput
  ) {
    deleteCert(input: $input, condition: $condition) {
      id
      name
      deleted
      updatedBy
      federal
      county
      countyInKind
      createdAt
      updatedAt
    }
  }
`;
export const createFiscalYear = /* GraphQL */ `
  mutation CreateFiscalYear(
    $input: CreateFiscalYearInput!
    $condition: ModelFiscalYearConditionInput
  ) {
    createFiscalYear(input: $input, condition: $condition) {
      id
      year
      grant
      availableToCounties
      createdAt
      updatedAt
      updatedBy
      acceptanceOfAuditReqFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      certificationDocumentFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      assurancesNonContructionFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      lobbyingCertificationFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      edmEquipmentPolicyFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      positionDescFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      acknowledgementFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      otherFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      scopeOfWorkFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      narrativesFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      guidelinesFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      extraFiles {
        items {
          id
          bucket
          title
          size
          downloadTitle
          createdAt
          updatedAt
          deleted
          updatedBy
        }
        nextToken
      }
    }
  }
`;
export const updateFiscalYear = /* GraphQL */ `
  mutation UpdateFiscalYear(
    $input: UpdateFiscalYearInput!
    $condition: ModelFiscalYearConditionInput
  ) {
    updateFiscalYear(input: $input, condition: $condition) {
      id
      year
      grant
      availableToCounties
      createdAt
      updatedAt
      updatedBy
      acceptanceOfAuditReqFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      certificationDocumentFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      assurancesNonContructionFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      lobbyingCertificationFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      edmEquipmentPolicyFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      positionDescFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      acknowledgementFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      otherFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      scopeOfWorkFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      narrativesFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      guidelinesFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      extraFiles {
        items {
          id
          bucket
          title
          size
          downloadTitle
          createdAt
          updatedAt
          deleted
          updatedBy
        }
        nextToken
      }
    }
  }
`;
export const deleteFiscalYear = /* GraphQL */ `
  mutation DeleteFiscalYear(
    $input: DeleteFiscalYearInput!
    $condition: ModelFiscalYearConditionInput
  ) {
    deleteFiscalYear(input: $input, condition: $condition) {
      id
      year
      grant
      availableToCounties
      createdAt
      updatedAt
      updatedBy
      acceptanceOfAuditReqFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      certificationDocumentFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      assurancesNonContructionFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      lobbyingCertificationFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      edmEquipmentPolicyFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      positionDescFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      acknowledgementFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      otherFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      scopeOfWorkFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      narrativesFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      guidelinesFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      extraFiles {
        items {
          id
          bucket
          title
          size
          downloadTitle
          createdAt
          updatedAt
          deleted
          updatedBy
        }
        nextToken
      }
    }
  }
`;
export const createGroup = /* GraphQL */ `
  mutation CreateGroup(
    $input: CreateGroupInput!
    $condition: ModelGroupConditionInput
  ) {
    createGroup(input: $input, condition: $condition) {
      id
      groupName
      createdAt
      updatedAt
      region
      palmettoId
      narratives {
        items {
          id
          completed
          createdAt
          updatedAt
          deleted
          updatedBy
          status
          notes
          extraFile
          quarter
          updatedByFirstName
          updatedByLastName
          year
          grant
        }
        nextToken
      }
      quarterlyprogressreporting {
        items {
          id
          quarter
          taskingslipstatus
          updatedAt
          updatedBy
          updatedByRemName
          createdAt
        }
        nextToken
      }
      awardAmount
      year
      grant
      deleted
      monitoringgrantinformation {
        id
        updatedAt
        createdAt
        updatedBy
        monitoringType
        monitoringDate
        subRecipientAgency
        grantProjectTitle
        grantNumber
        approvedGrantStartDate
        approvedGrantEndDate
        extensionEndDate
        name
        title
        projectDirectorName
        projectDirectorTitle
        personnelName
        personnelTitle
      }
      monitoringsitevisitreview {
        id
        updatedAt
        createdAt
        updatedBy
        gaOnFile
        gaSupportingDocumentationOnFile
        gaComments
        personnelFunded
        personnelDocumentationOnFile
        personnelRecordsOnFile
        personnelComments
        contractualServiceOnFile
        contractualServiceExecutedContractsOnFile
        contractualServiceComments
        travelOnFile
        travelDocumentationOnFile
        travelComments
        equipmentProperlySheltered
        equipmentTransferred
        equipmentComments
        suppliesOnFile
        suppliesTransferred
        suppliesComments
        otherOnFile
        otherComments
        summaryComments
        monitoringReportSubmittedBy
        monitoringReportSubmittedAt
        scemdPOCReviewedBy
        scemdPOCReviewedAt
        monitoringFiles {
          nextToken
        }
        status
      }
      grantapplication {
        items {
          id
          updatedBy
          version
          versionName
          createdAt
          updatedAt
          year
          deleted
          status
          awarded
          deductCertFromFederal
          salaryNarrative
          fringeBenefitNarrative
          fbFederalFunding
          fbCountyCashFunding
          fbCountyInkindFunding
          contractualServiceNarrative
          travelNarrative
          equipmentNarrative
          supplyNarrative
          otherNarrative
          certNarrative
          extraFile
          changesRequestedOnApplication
          name
          address
          address2
          city
          state
          county
          zipcode
          latitude
          longitude
          enableReverseGeocoding
          implementingAgency
          phoneNumber
          faxNumber
          currentApplicationRevisionId
        }
        nextToken
      }
      financialreimbursement {
        items {
          id
          quarter
          quarterStartDate
          quarterEndDate
          updatedBy
          year
          createdAt
          updatedAt
          deleted
          status
          awarded
          checkNumber
          checkAmount
          checkMailDate
          stateSceisDocumentNumber
          stateSceisSubmissionDate
          checkNumber2
          checkAmount2
          checkMailDate2
          stateSceisDocumentNumber2
          stateSceisSubmissionDate2
          reason2
          deobligatedFunds
          deobligatedFundsReason
        }
        nextToken
      }
    }
  }
`;
export const updateGroup = /* GraphQL */ `
  mutation UpdateGroup(
    $input: UpdateGroupInput!
    $condition: ModelGroupConditionInput
  ) {
    updateGroup(input: $input, condition: $condition) {
      id
      groupName
      createdAt
      updatedAt
      region
      palmettoId
      narratives {
        items {
          id
          completed
          createdAt
          updatedAt
          deleted
          updatedBy
          status
          notes
          extraFile
          quarter
          updatedByFirstName
          updatedByLastName
          year
          grant
        }
        nextToken
      }
      quarterlyprogressreporting {
        items {
          id
          quarter
          taskingslipstatus
          updatedAt
          updatedBy
          updatedByRemName
          createdAt
        }
        nextToken
      }
      awardAmount
      year
      grant
      deleted
      monitoringgrantinformation {
        id
        updatedAt
        createdAt
        updatedBy
        monitoringType
        monitoringDate
        subRecipientAgency
        grantProjectTitle
        grantNumber
        approvedGrantStartDate
        approvedGrantEndDate
        extensionEndDate
        name
        title
        projectDirectorName
        projectDirectorTitle
        personnelName
        personnelTitle
      }
      monitoringsitevisitreview {
        id
        updatedAt
        createdAt
        updatedBy
        gaOnFile
        gaSupportingDocumentationOnFile
        gaComments
        personnelFunded
        personnelDocumentationOnFile
        personnelRecordsOnFile
        personnelComments
        contractualServiceOnFile
        contractualServiceExecutedContractsOnFile
        contractualServiceComments
        travelOnFile
        travelDocumentationOnFile
        travelComments
        equipmentProperlySheltered
        equipmentTransferred
        equipmentComments
        suppliesOnFile
        suppliesTransferred
        suppliesComments
        otherOnFile
        otherComments
        summaryComments
        monitoringReportSubmittedBy
        monitoringReportSubmittedAt
        scemdPOCReviewedBy
        scemdPOCReviewedAt
        monitoringFiles {
          nextToken
        }
        status
      }
      grantapplication {
        items {
          id
          updatedBy
          version
          versionName
          createdAt
          updatedAt
          year
          deleted
          status
          awarded
          deductCertFromFederal
          salaryNarrative
          fringeBenefitNarrative
          fbFederalFunding
          fbCountyCashFunding
          fbCountyInkindFunding
          contractualServiceNarrative
          travelNarrative
          equipmentNarrative
          supplyNarrative
          otherNarrative
          certNarrative
          extraFile
          changesRequestedOnApplication
          name
          address
          address2
          city
          state
          county
          zipcode
          latitude
          longitude
          enableReverseGeocoding
          implementingAgency
          phoneNumber
          faxNumber
          currentApplicationRevisionId
        }
        nextToken
      }
      financialreimbursement {
        items {
          id
          quarter
          quarterStartDate
          quarterEndDate
          updatedBy
          year
          createdAt
          updatedAt
          deleted
          status
          awarded
          checkNumber
          checkAmount
          checkMailDate
          stateSceisDocumentNumber
          stateSceisSubmissionDate
          checkNumber2
          checkAmount2
          checkMailDate2
          stateSceisDocumentNumber2
          stateSceisSubmissionDate2
          reason2
          deobligatedFunds
          deobligatedFundsReason
        }
        nextToken
      }
    }
  }
`;
export const deleteGroup = /* GraphQL */ `
  mutation DeleteGroup(
    $input: DeleteGroupInput!
    $condition: ModelGroupConditionInput
  ) {
    deleteGroup(input: $input, condition: $condition) {
      id
      groupName
      createdAt
      updatedAt
      region
      palmettoId
      narratives {
        items {
          id
          completed
          createdAt
          updatedAt
          deleted
          updatedBy
          status
          notes
          extraFile
          quarter
          updatedByFirstName
          updatedByLastName
          year
          grant
        }
        nextToken
      }
      quarterlyprogressreporting {
        items {
          id
          quarter
          taskingslipstatus
          updatedAt
          updatedBy
          updatedByRemName
          createdAt
        }
        nextToken
      }
      awardAmount
      year
      grant
      deleted
      monitoringgrantinformation {
        id
        updatedAt
        createdAt
        updatedBy
        monitoringType
        monitoringDate
        subRecipientAgency
        grantProjectTitle
        grantNumber
        approvedGrantStartDate
        approvedGrantEndDate
        extensionEndDate
        name
        title
        projectDirectorName
        projectDirectorTitle
        personnelName
        personnelTitle
      }
      monitoringsitevisitreview {
        id
        updatedAt
        createdAt
        updatedBy
        gaOnFile
        gaSupportingDocumentationOnFile
        gaComments
        personnelFunded
        personnelDocumentationOnFile
        personnelRecordsOnFile
        personnelComments
        contractualServiceOnFile
        contractualServiceExecutedContractsOnFile
        contractualServiceComments
        travelOnFile
        travelDocumentationOnFile
        travelComments
        equipmentProperlySheltered
        equipmentTransferred
        equipmentComments
        suppliesOnFile
        suppliesTransferred
        suppliesComments
        otherOnFile
        otherComments
        summaryComments
        monitoringReportSubmittedBy
        monitoringReportSubmittedAt
        scemdPOCReviewedBy
        scemdPOCReviewedAt
        monitoringFiles {
          nextToken
        }
        status
      }
      grantapplication {
        items {
          id
          updatedBy
          version
          versionName
          createdAt
          updatedAt
          year
          deleted
          status
          awarded
          deductCertFromFederal
          salaryNarrative
          fringeBenefitNarrative
          fbFederalFunding
          fbCountyCashFunding
          fbCountyInkindFunding
          contractualServiceNarrative
          travelNarrative
          equipmentNarrative
          supplyNarrative
          otherNarrative
          certNarrative
          extraFile
          changesRequestedOnApplication
          name
          address
          address2
          city
          state
          county
          zipcode
          latitude
          longitude
          enableReverseGeocoding
          implementingAgency
          phoneNumber
          faxNumber
          currentApplicationRevisionId
        }
        nextToken
      }
      financialreimbursement {
        items {
          id
          quarter
          quarterStartDate
          quarterEndDate
          updatedBy
          year
          createdAt
          updatedAt
          deleted
          status
          awarded
          checkNumber
          checkAmount
          checkMailDate
          stateSceisDocumentNumber
          stateSceisSubmissionDate
          checkNumber2
          checkAmount2
          checkMailDate2
          stateSceisDocumentNumber2
          stateSceisSubmissionDate2
          reason2
          deobligatedFunds
          deobligatedFundsReason
        }
        nextToken
      }
    }
  }
`;
export const createMonitoringGrantInformation = /* GraphQL */ `
  mutation CreateMonitoringGrantInformation(
    $input: CreateMonitoringGrantInformationInput!
    $condition: ModelMonitoringGrantInformationConditionInput
  ) {
    createMonitoringGrantInformation(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      monitoringType
      monitoringDate
      subRecipientAgency
      grantProjectTitle
      grantNumber
      approvedGrantStartDate
      approvedGrantEndDate
      extensionEndDate
      name
      title
      projectDirectorName
      projectDirectorTitle
      personnelName
      personnelTitle
    }
  }
`;
export const updateMonitoringGrantInformation = /* GraphQL */ `
  mutation UpdateMonitoringGrantInformation(
    $input: UpdateMonitoringGrantInformationInput!
    $condition: ModelMonitoringGrantInformationConditionInput
  ) {
    updateMonitoringGrantInformation(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      monitoringType
      monitoringDate
      subRecipientAgency
      grantProjectTitle
      grantNumber
      approvedGrantStartDate
      approvedGrantEndDate
      extensionEndDate
      name
      title
      projectDirectorName
      projectDirectorTitle
      personnelName
      personnelTitle
    }
  }
`;
export const deleteMonitoringGrantInformation = /* GraphQL */ `
  mutation DeleteMonitoringGrantInformation(
    $input: DeleteMonitoringGrantInformationInput!
    $condition: ModelMonitoringGrantInformationConditionInput
  ) {
    deleteMonitoringGrantInformation(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      monitoringType
      monitoringDate
      subRecipientAgency
      grantProjectTitle
      grantNumber
      approvedGrantStartDate
      approvedGrantEndDate
      extensionEndDate
      name
      title
      projectDirectorName
      projectDirectorTitle
      personnelName
      personnelTitle
    }
  }
`;
export const createMonitoringSiteVisitReview = /* GraphQL */ `
  mutation CreateMonitoringSiteVisitReview(
    $input: CreateMonitoringSiteVisitReviewInput!
    $condition: ModelMonitoringSiteVisitReviewConditionInput
  ) {
    createMonitoringSiteVisitReview(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      gaOnFile
      gaSupportingDocumentationOnFile
      gaComments
      personnelFunded
      personnelDocumentationOnFile
      personnelRecordsOnFile
      personnelComments
      contractualServiceOnFile
      contractualServiceExecutedContractsOnFile
      contractualServiceComments
      travelOnFile
      travelDocumentationOnFile
      travelComments
      equipmentProperlySheltered
      equipmentTransferred
      equipmentComments
      suppliesOnFile
      suppliesTransferred
      suppliesComments
      otherOnFile
      otherComments
      summaryComments
      monitoringReportSubmittedBy
      monitoringReportSubmittedAt
      scemdPOCReviewedBy
      scemdPOCReviewedAt
      monitoringFiles {
        items {
          id
          bucket
          title
          size
          downloadTitle
          createdAt
          updatedAt
          deleted
          updatedBy
        }
        nextToken
      }
      status
    }
  }
`;
export const updateMonitoringSiteVisitReview = /* GraphQL */ `
  mutation UpdateMonitoringSiteVisitReview(
    $input: UpdateMonitoringSiteVisitReviewInput!
    $condition: ModelMonitoringSiteVisitReviewConditionInput
  ) {
    updateMonitoringSiteVisitReview(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      gaOnFile
      gaSupportingDocumentationOnFile
      gaComments
      personnelFunded
      personnelDocumentationOnFile
      personnelRecordsOnFile
      personnelComments
      contractualServiceOnFile
      contractualServiceExecutedContractsOnFile
      contractualServiceComments
      travelOnFile
      travelDocumentationOnFile
      travelComments
      equipmentProperlySheltered
      equipmentTransferred
      equipmentComments
      suppliesOnFile
      suppliesTransferred
      suppliesComments
      otherOnFile
      otherComments
      summaryComments
      monitoringReportSubmittedBy
      monitoringReportSubmittedAt
      scemdPOCReviewedBy
      scemdPOCReviewedAt
      monitoringFiles {
        items {
          id
          bucket
          title
          size
          downloadTitle
          createdAt
          updatedAt
          deleted
          updatedBy
        }
        nextToken
      }
      status
    }
  }
`;
export const deleteMonitoringSiteVisitReview = /* GraphQL */ `
  mutation DeleteMonitoringSiteVisitReview(
    $input: DeleteMonitoringSiteVisitReviewInput!
    $condition: ModelMonitoringSiteVisitReviewConditionInput
  ) {
    deleteMonitoringSiteVisitReview(input: $input, condition: $condition) {
      id
      updatedAt
      createdAt
      updatedBy
      gaOnFile
      gaSupportingDocumentationOnFile
      gaComments
      personnelFunded
      personnelDocumentationOnFile
      personnelRecordsOnFile
      personnelComments
      contractualServiceOnFile
      contractualServiceExecutedContractsOnFile
      contractualServiceComments
      travelOnFile
      travelDocumentationOnFile
      travelComments
      equipmentProperlySheltered
      equipmentTransferred
      equipmentComments
      suppliesOnFile
      suppliesTransferred
      suppliesComments
      otherOnFile
      otherComments
      summaryComments
      monitoringReportSubmittedBy
      monitoringReportSubmittedAt
      scemdPOCReviewedBy
      scemdPOCReviewedAt
      monitoringFiles {
        items {
          id
          bucket
          title
          size
          downloadTitle
          createdAt
          updatedAt
          deleted
          updatedBy
        }
        nextToken
      }
      status
    }
  }
`;
export const createQuarterlyProgressReporting = /* GraphQL */ `
  mutation CreateQuarterlyProgressReporting(
    $input: CreateQuarterlyProgressReportingInput!
    $condition: ModelQuarterlyProgressReportingConditionInput
  ) {
    createQuarterlyProgressReporting(input: $input, condition: $condition) {
      id
      quarter
      taskingslipstatus
      updatedAt
      updatedBy
      updatedByRemName
      createdAt
    }
  }
`;
export const updateQuarterlyProgressReporting = /* GraphQL */ `
  mutation UpdateQuarterlyProgressReporting(
    $input: UpdateQuarterlyProgressReportingInput!
    $condition: ModelQuarterlyProgressReportingConditionInput
  ) {
    updateQuarterlyProgressReporting(input: $input, condition: $condition) {
      id
      quarter
      taskingslipstatus
      updatedAt
      updatedBy
      updatedByRemName
      createdAt
    }
  }
`;
export const deleteQuarterlyProgressReporting = /* GraphQL */ `
  mutation DeleteQuarterlyProgressReporting(
    $input: DeleteQuarterlyProgressReportingInput!
    $condition: ModelQuarterlyProgressReportingConditionInput
  ) {
    deleteQuarterlyProgressReporting(input: $input, condition: $condition) {
      id
      quarter
      taskingslipstatus
      updatedAt
      updatedBy
      updatedByRemName
      createdAt
    }
  }
`;
export const createNarrative = /* GraphQL */ `
  mutation CreateNarrative(
    $input: CreateNarrativeInput!
    $condition: ModelNarrativeConditionInput
  ) {
    createNarrative(input: $input, condition: $condition) {
      id
      narrativeTitle
      narrativeCategory
      narrativeShortDescription
      narrativeLongDescription
      narrativeFrequency
      usePalmettoForREMInformation
      useFinancialReimbursementStatus
      narrativePOCFirstName
      narrativePOCLastName
      narrativePOCPhoneNumber
      narrativePOCEmailAddress
      narrativePOCPositionTitle
      quarter
      deleted
      createdAt
      updatedAt
      updatedBy
      year
      grant
      uploadedFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      groups {
        items {
          id
          completed
          createdAt
          updatedAt
          deleted
          updatedBy
          status
          notes
          extraFile
          quarter
          updatedByFirstName
          updatedByLastName
          year
          grant
        }
        nextToken
      }
    }
  }
`;
export const updateNarrative = /* GraphQL */ `
  mutation UpdateNarrative(
    $input: UpdateNarrativeInput!
    $condition: ModelNarrativeConditionInput
  ) {
    updateNarrative(input: $input, condition: $condition) {
      id
      narrativeTitle
      narrativeCategory
      narrativeShortDescription
      narrativeLongDescription
      narrativeFrequency
      usePalmettoForREMInformation
      useFinancialReimbursementStatus
      narrativePOCFirstName
      narrativePOCLastName
      narrativePOCPhoneNumber
      narrativePOCEmailAddress
      narrativePOCPositionTitle
      quarter
      deleted
      createdAt
      updatedAt
      updatedBy
      year
      grant
      uploadedFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      groups {
        items {
          id
          completed
          createdAt
          updatedAt
          deleted
          updatedBy
          status
          notes
          extraFile
          quarter
          updatedByFirstName
          updatedByLastName
          year
          grant
        }
        nextToken
      }
    }
  }
`;
export const deleteNarrative = /* GraphQL */ `
  mutation DeleteNarrative(
    $input: DeleteNarrativeInput!
    $condition: ModelNarrativeConditionInput
  ) {
    deleteNarrative(input: $input, condition: $condition) {
      id
      narrativeTitle
      narrativeCategory
      narrativeShortDescription
      narrativeLongDescription
      narrativeFrequency
      usePalmettoForREMInformation
      useFinancialReimbursementStatus
      narrativePOCFirstName
      narrativePOCLastName
      narrativePOCPhoneNumber
      narrativePOCEmailAddress
      narrativePOCPositionTitle
      quarter
      deleted
      createdAt
      updatedAt
      updatedBy
      year
      grant
      uploadedFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      groups {
        items {
          id
          completed
          createdAt
          updatedAt
          deleted
          updatedBy
          status
          notes
          extraFile
          quarter
          updatedByFirstName
          updatedByLastName
          year
          grant
        }
        nextToken
      }
    }
  }
`;
export const createGroupNarrativeM2M = /* GraphQL */ `
  mutation CreateGroupNarrativeM2M(
    $input: CreateGroupNarrativeM2MInput!
    $condition: ModelGroupNarrativeM2MConditionInput
  ) {
    createGroupNarrativeM2M(input: $input, condition: $condition) {
      id
      narrative {
        id
        narrativeTitle
        narrativeCategory
        narrativeShortDescription
        narrativeLongDescription
        narrativeFrequency
        usePalmettoForREMInformation
        useFinancialReimbursementStatus
        narrativePOCFirstName
        narrativePOCLastName
        narrativePOCPhoneNumber
        narrativePOCEmailAddress
        narrativePOCPositionTitle
        quarter
        deleted
        createdAt
        updatedAt
        updatedBy
        year
        grant
        uploadedFile {
          id
          bucket
          title
          size
          downloadTitle
          createdAt
          updatedAt
          deleted
          updatedBy
        }
        groups {
          nextToken
        }
      }
      group {
        id
        groupName
        createdAt
        updatedAt
        region
        palmettoId
        narratives {
          nextToken
        }
        quarterlyprogressreporting {
          nextToken
        }
        awardAmount
        year
        grant
        deleted
        monitoringgrantinformation {
          id
          updatedAt
          createdAt
          updatedBy
          monitoringType
          monitoringDate
          subRecipientAgency
          grantProjectTitle
          grantNumber
          approvedGrantStartDate
          approvedGrantEndDate
          extensionEndDate
          name
          title
          projectDirectorName
          projectDirectorTitle
          personnelName
          personnelTitle
        }
        monitoringsitevisitreview {
          id
          updatedAt
          createdAt
          updatedBy
          gaOnFile
          gaSupportingDocumentationOnFile
          gaComments
          personnelFunded
          personnelDocumentationOnFile
          personnelRecordsOnFile
          personnelComments
          contractualServiceOnFile
          contractualServiceExecutedContractsOnFile
          contractualServiceComments
          travelOnFile
          travelDocumentationOnFile
          travelComments
          equipmentProperlySheltered
          equipmentTransferred
          equipmentComments
          suppliesOnFile
          suppliesTransferred
          suppliesComments
          otherOnFile
          otherComments
          summaryComments
          monitoringReportSubmittedBy
          monitoringReportSubmittedAt
          scemdPOCReviewedBy
          scemdPOCReviewedAt
          status
        }
        grantapplication {
          nextToken
        }
        financialreimbursement {
          nextToken
        }
      }
      completed
      createdAt
      updatedAt
      deleted
      updatedBy
      status
      notes
      uploadedFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      extraFile
      quarter
      updatedByFirstName
      updatedByLastName
      year
      grant
      extensions {
        items {
          id
          updatedAt
          createdAt
          updatedBy
          year
          grant
          type
          group
          status
          for
          quarterFrom
          quarterTo
          dueDate
          reasonForExtension
          dateAdjustedTo
          reasonForAdjustment
          reasonForDeniedExtension
        }
        nextToken
      }
      currentExtension {
        id
        updatedAt
        createdAt
        updatedBy
        year
        grant
        type
        group
        status
        for
        quarterFrom
        quarterTo
        dueDate
        reasonForExtension
        dateAdjustedTo
        reasonForAdjustment
        reasonForDeniedExtension
      }
      m117CompletedDocument {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      comments {
        items {
          id
          comment
          createdAt
          updatedAt
          deleted
          updatedBy
          updatedByFirstName
          updatedByLastName
        }
        nextToken
      }
    }
  }
`;
export const updateGroupNarrativeM2M = /* GraphQL */ `
  mutation UpdateGroupNarrativeM2M(
    $input: UpdateGroupNarrativeM2MInput!
    $condition: ModelGroupNarrativeM2MConditionInput
  ) {
    updateGroupNarrativeM2M(input: $input, condition: $condition) {
      id
      narrative {
        id
        narrativeTitle
        narrativeCategory
        narrativeShortDescription
        narrativeLongDescription
        narrativeFrequency
        usePalmettoForREMInformation
        useFinancialReimbursementStatus
        narrativePOCFirstName
        narrativePOCLastName
        narrativePOCPhoneNumber
        narrativePOCEmailAddress
        narrativePOCPositionTitle
        quarter
        deleted
        createdAt
        updatedAt
        updatedBy
        year
        grant
        uploadedFile {
          id
          bucket
          title
          size
          downloadTitle
          createdAt
          updatedAt
          deleted
          updatedBy
        }
        groups {
          nextToken
        }
      }
      group {
        id
        groupName
        createdAt
        updatedAt
        region
        palmettoId
        narratives {
          nextToken
        }
        quarterlyprogressreporting {
          nextToken
        }
        awardAmount
        year
        grant
        deleted
        monitoringgrantinformation {
          id
          updatedAt
          createdAt
          updatedBy
          monitoringType
          monitoringDate
          subRecipientAgency
          grantProjectTitle
          grantNumber
          approvedGrantStartDate
          approvedGrantEndDate
          extensionEndDate
          name
          title
          projectDirectorName
          projectDirectorTitle
          personnelName
          personnelTitle
        }
        monitoringsitevisitreview {
          id
          updatedAt
          createdAt
          updatedBy
          gaOnFile
          gaSupportingDocumentationOnFile
          gaComments
          personnelFunded
          personnelDocumentationOnFile
          personnelRecordsOnFile
          personnelComments
          contractualServiceOnFile
          contractualServiceExecutedContractsOnFile
          contractualServiceComments
          travelOnFile
          travelDocumentationOnFile
          travelComments
          equipmentProperlySheltered
          equipmentTransferred
          equipmentComments
          suppliesOnFile
          suppliesTransferred
          suppliesComments
          otherOnFile
          otherComments
          summaryComments
          monitoringReportSubmittedBy
          monitoringReportSubmittedAt
          scemdPOCReviewedBy
          scemdPOCReviewedAt
          status
        }
        grantapplication {
          nextToken
        }
        financialreimbursement {
          nextToken
        }
      }
      completed
      createdAt
      updatedAt
      deleted
      updatedBy
      status
      notes
      uploadedFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      extraFile
      quarter
      updatedByFirstName
      updatedByLastName
      year
      grant
      extensions {
        items {
          id
          updatedAt
          createdAt
          updatedBy
          year
          grant
          type
          group
          status
          for
          quarterFrom
          quarterTo
          dueDate
          reasonForExtension
          dateAdjustedTo
          reasonForAdjustment
          reasonForDeniedExtension
        }
        nextToken
      }
      currentExtension {
        id
        updatedAt
        createdAt
        updatedBy
        year
        grant
        type
        group
        status
        for
        quarterFrom
        quarterTo
        dueDate
        reasonForExtension
        dateAdjustedTo
        reasonForAdjustment
        reasonForDeniedExtension
      }
      m117CompletedDocument {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      comments {
        items {
          id
          comment
          createdAt
          updatedAt
          deleted
          updatedBy
          updatedByFirstName
          updatedByLastName
        }
        nextToken
      }
    }
  }
`;
export const deleteGroupNarrativeM2M = /* GraphQL */ `
  mutation DeleteGroupNarrativeM2M(
    $input: DeleteGroupNarrativeM2MInput!
    $condition: ModelGroupNarrativeM2MConditionInput
  ) {
    deleteGroupNarrativeM2M(input: $input, condition: $condition) {
      id
      narrative {
        id
        narrativeTitle
        narrativeCategory
        narrativeShortDescription
        narrativeLongDescription
        narrativeFrequency
        usePalmettoForREMInformation
        useFinancialReimbursementStatus
        narrativePOCFirstName
        narrativePOCLastName
        narrativePOCPhoneNumber
        narrativePOCEmailAddress
        narrativePOCPositionTitle
        quarter
        deleted
        createdAt
        updatedAt
        updatedBy
        year
        grant
        uploadedFile {
          id
          bucket
          title
          size
          downloadTitle
          createdAt
          updatedAt
          deleted
          updatedBy
        }
        groups {
          nextToken
        }
      }
      group {
        id
        groupName
        createdAt
        updatedAt
        region
        palmettoId
        narratives {
          nextToken
        }
        quarterlyprogressreporting {
          nextToken
        }
        awardAmount
        year
        grant
        deleted
        monitoringgrantinformation {
          id
          updatedAt
          createdAt
          updatedBy
          monitoringType
          monitoringDate
          subRecipientAgency
          grantProjectTitle
          grantNumber
          approvedGrantStartDate
          approvedGrantEndDate
          extensionEndDate
          name
          title
          projectDirectorName
          projectDirectorTitle
          personnelName
          personnelTitle
        }
        monitoringsitevisitreview {
          id
          updatedAt
          createdAt
          updatedBy
          gaOnFile
          gaSupportingDocumentationOnFile
          gaComments
          personnelFunded
          personnelDocumentationOnFile
          personnelRecordsOnFile
          personnelComments
          contractualServiceOnFile
          contractualServiceExecutedContractsOnFile
          contractualServiceComments
          travelOnFile
          travelDocumentationOnFile
          travelComments
          equipmentProperlySheltered
          equipmentTransferred
          equipmentComments
          suppliesOnFile
          suppliesTransferred
          suppliesComments
          otherOnFile
          otherComments
          summaryComments
          monitoringReportSubmittedBy
          monitoringReportSubmittedAt
          scemdPOCReviewedBy
          scemdPOCReviewedAt
          status
        }
        grantapplication {
          nextToken
        }
        financialreimbursement {
          nextToken
        }
      }
      completed
      createdAt
      updatedAt
      deleted
      updatedBy
      status
      notes
      uploadedFile {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      extraFile
      quarter
      updatedByFirstName
      updatedByLastName
      year
      grant
      extensions {
        items {
          id
          updatedAt
          createdAt
          updatedBy
          year
          grant
          type
          group
          status
          for
          quarterFrom
          quarterTo
          dueDate
          reasonForExtension
          dateAdjustedTo
          reasonForAdjustment
          reasonForDeniedExtension
        }
        nextToken
      }
      currentExtension {
        id
        updatedAt
        createdAt
        updatedBy
        year
        grant
        type
        group
        status
        for
        quarterFrom
        quarterTo
        dueDate
        reasonForExtension
        dateAdjustedTo
        reasonForAdjustment
        reasonForDeniedExtension
      }
      m117CompletedDocument {
        id
        bucket
        title
        size
        downloadTitle
        createdAt
        updatedAt
        deleted
        updatedBy
      }
      comments {
        items {
          id
          comment
          createdAt
          updatedAt
          deleted
          updatedBy
          updatedByFirstName
          updatedByLastName
        }
        nextToken
      }
    }
  }
`;
export const createRemContact = /* GraphQL */ `
  mutation CreateRemContact(
    $input: CreateREMContactInput!
    $condition: ModelREMContactConditionInput
  ) {
    createREMContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      emailAddress
      phoneNumber
      region
      deleted
      createdAt
      updatedAt
      updatedBy
      positionTitle
      year
    }
  }
`;
export const updateRemContact = /* GraphQL */ `
  mutation UpdateRemContact(
    $input: UpdateREMContactInput!
    $condition: ModelREMContactConditionInput
  ) {
    updateREMContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      emailAddress
      phoneNumber
      region
      deleted
      createdAt
      updatedAt
      updatedBy
      positionTitle
      year
    }
  }
`;
export const deleteRemContact = /* GraphQL */ `
  mutation DeleteRemContact(
    $input: DeleteREMContactInput!
    $condition: ModelREMContactConditionInput
  ) {
    deleteREMContact(input: $input, condition: $condition) {
      id
      firstName
      lastName
      emailAddress
      phoneNumber
      region
      deleted
      createdAt
      updatedAt
      updatedBy
      positionTitle
      year
    }
  }
`;
